import { render, staticRenderFns } from "./Lead.vue?vue&type=template&id=71a47b88&scoped=true&"
import script from "./Lead.vue?vue&type=script&lang=js&"
export * from "./Lead.vue?vue&type=script&lang=js&"
import style0 from "./Lead.vue?vue&type=style&index=0&id=71a47b88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a47b88",
  null
  
)

export default component.exports